module.exports = __webpack_public_path__ + "img/fr-FR-add-to-google-wallet.2b123f2.svg";